module.exports = __webpack_public_path__ + "img/Recurso 39@300x.201d5d20.png";